import React, { useState } from 'react';

import { I18n } from 'react-redux-i18n';
import { Form, Modal, Button, Checkbox } from 'semantic-ui-react';

import { Record } from '../../../../modules/bin/utility';
import CurrencyHelper from '../../../../helpers/currencyHelper';
import config from '../../../../constants';

const ApplicationConfirmationModal = ({
  open,
  showDisableEmailCheckbox = false,
  disableAutomaticEmail = false,
  handleConfirm,
  translationKey,
  handleClose,
  record,
  handleModalStateChange = () => {},
  eventAmbassadorRecord
}) => {
  const [skipRegistrationFee, setSkipRegistrationFee] = useState(false);
  const [skipReason, setSkipReason] = useState('');
  const isLoading = Record.isRecordLoading(record);

  // Check if this is a rejection modal and if the eventAmbassador has a donation plan
  const isRejectModal = translationKey.includes('reject-modal');
  const hasDonationPlan = eventAmbassadorRecord?.data?.data?.hasDonationPlan;

  const isAcceptModal = translationKey.includes('accept-modal');
  const registrationFee = eventAmbassadorRecord?.data?.data?.registrationFee;
  const offersRegistrationFee = isAcceptModal && registrationFee?.enabled;
  const chargesRegistrationFee = offersRegistrationFee && !skipRegistrationFee;
  const skipsRegistrationFee = offersRegistrationFee && skipRegistrationFee;
  // Skipping the fee has to be explained; the reason is kept with the application for good.
  const trimmedSkipReason = skipReason.trim();
  const skipReasonMissing = skipsRegistrationFee && !trimmedSkipReason;
  const confirmation = skipsRegistrationFee
    ? { skipRegistrationFee, skipReason: trimmedSkipReason }
    : { skipRegistrationFee };

  return (
    <Modal
      className="application-confirmation-modal"
      size="tiny"
      dimmer="inverted"
      open={open}
    >
      <Modal.Header>
        <label>{I18n.t(`${translationKey}.title`)}</label>
      </Modal.Header>
      <Modal.Content className="application-confirmation-modal-content">
        <span>
          {chargesRegistrationFee
            ? I18n.t(`${translationKey}.content-with-registration-fee`, {
                amount: CurrencyHelper.formatCurrency(
                  registrationFee.amount,
                  registrationFee.currency
                )
              })
            : I18n.t(`${translationKey}.content`)}
        </span>

        {/* Additional warning text for rejection modal */}
        {isRejectModal && (
          <div style={{ marginTop: '10px' }}>
            <p>
              {I18n.t(`${translationKey}.archive-fundraising-page`)}
              {hasDonationPlan && (
                <>
                  <br />
                  {I18n.t(`${translationKey}.remove-card-on-file`)}
                </>
              )}
            </p>
          </div>
        )}

        {offersRegistrationFee && (
          <Form.Field className="skip-registration-fee-checkbox">
            <Checkbox
              checked={skipRegistrationFee}
              onChange={(event, { checked }) => setSkipRegistrationFee(checked)}
              label={I18n.t(`${translationKey}.skip-registration-fee`)}
            />
          </Form.Field>
        )}
        {skipsRegistrationFee && (
          <Form.Field className="skip-registration-fee-reason">
            <label htmlFor="skipRegistrationFeeReason">
              {I18n.t(`${translationKey}.skip-reason.label`)}
            </label>
            <textarea
              id="skipRegistrationFeeReason"
              rows={3}
              maxLength={config.REGISTRATION_FEE_SKIP_REASON_MAX_LENGTH}
              required
              value={skipReason}
              placeholder={I18n.t(`${translationKey}.skip-reason.placeholder`)}
              onChange={(event) => setSkipReason(event.target.value)}
            />
          </Form.Field>
        )}
        {showDisableEmailCheckbox && (
          <Form.Field className="disable-automatic-email-checkbox">
            <Checkbox
              checked={disableAutomaticEmail}
              onChange={(event, { checked }) => {
                handleModalStateChange(
                  'applicationConfirmationModal.disableAutomaticEmail',
                  checked
                );
              }}
              label={I18n.t(
                `${translationKey}.disable-automatic-email.checkbox`
              )}
            />
          </Form.Field>
        )}
        <div className="application-confirmation-modal-buttons">
          <Button
            primary
            className="accept-button"
            onClick={() => handleConfirm(confirmation)}
            loading={isLoading}
            disabled={skipReasonMissing || isLoading}
          >
            {I18n.t(`${translationKey}.accept-button`)}
          </Button>
          <Button onClick={handleClose}>
            {I18n.t(`${translationKey}.decline-button`)}
          </Button>
        </div>
      </Modal.Content>
    </Modal>
  );
};

export default ApplicationConfirmationModal;
